import { use } from "react";

import type { ConnectionState } from "./ConnectionState";
import { RealtimeContext } from "./RealtimeContext";

// Состояние соединения. Пока не `"connected"`, экран, который ждёт результат,
// опрашивает API (`refetchInterval`).
export const useConnectionState = (): ConnectionState => use(RealtimeContext);
